import { Node, mergeAttributes } from '@tiptap/core';

const TranscriptExtension = Node.create({
  name: "transcript",
  group: "block",
  defining: true,
  addAttributes() {
    return {
      for: {
        default: null,
        keepOnSplit: true,
        isRequired: true,
        parseHTML: (element) => element.getAttribute("data-for"),
        renderHTML: (attributes) => ({
          ["data-for"]: attributes["for"]
        })
      }
    };
  },
  content() {
    return "transcriptItem+";
  },
  parseHTML() {
    return [
      {
        tag: "div",
        getAttrs: (node) => {
          const domNode = node;
          const role = domNode.getAttribute("data-role");
          return role === "transcript" ? {} : false;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        ["data-role"]: "transcript"
      }),
      0
    ];
  }
});

export { TranscriptExtension };
//# sourceMappingURL=TranscriptExtension.js.map
